export const Str = {
  snakeToCamel: (str: string) => {
    return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase())
  },
  camelToSnake: (str: string) => {
    return str.replace(/([A-Z])/g, '_$1').toLowerCase()
  }
}
